module.exports = __webpack_public_path__ + "img/layer.a0e35b02.png";